import { render, staticRenderFns } from "./PlaceCommentsModal.vue?vue&type=template&id=1f0743df&scoped=true&"
import script from "./PlaceCommentsModal.vue?vue&type=script&lang=js&"
export * from "./PlaceCommentsModal.vue?vue&type=script&lang=js&"
import style0 from "./PlaceCommentsModal.vue?vue&type=style&index=0&id=1f0743df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0743df",
  null
  
)

export default component.exports